module.exports = __webpack_public_path__ + "4f1f57f6d4bf50934ab9404436ba9073.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/disease_large_black.png
 ** module id = 1053
 ** module chunks = 0
 **/